module.exports = __webpack_public_path__ + "img/antena.d317a3e5.webp";